import React from 'react';
import styled, { css } from 'styled-components';
import { OldCoupleAlt } from './icons/OldCoupleAlt';

function AdultIcon() {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.08333 5.83333C7.46636 5.83333 7.84563 5.75789 8.19949 5.61132C8.55336 5.46474 8.87489 5.2499 9.14573 4.97906C9.41657 4.70822 9.6314 4.38669 9.77798 4.03283C9.92456 3.67896 10 3.29969 10 2.91667C10 2.53364 9.92456 2.15437 9.77798 1.80051C9.6314 1.44664 9.41657 1.12511 9.14573 0.854272C8.87489 0.583435 8.55336 0.368594 8.19949 0.222018C7.84563 0.0754419 7.46636 -5.70747e-09 7.08333 0C6.30978 1.15268e-08 5.56792 0.307291 5.02094 0.854272C4.47396 1.40125 4.16667 2.14312 4.16667 2.91667C4.16667 3.69021 4.47396 4.43208 5.02094 4.97906C5.56792 5.52604 6.30978 5.83333 7.08333 5.83333ZM11.3733 11.6667C11.415 11.96 11.4517 12.2742 11.4833 12.6017C11.6667 14.4725 11.6667 16.5 11.6667 17.0833C11.6667 17.4149 11.7984 17.7328 12.0328 17.9672C12.2672 18.2016 12.5851 18.3333 12.9167 18.3333C13.2482 18.3333 13.5661 18.2016 13.8005 17.9672C14.035 17.7328 14.1667 17.4149 14.1667 17.0833V17.0775C14.1667 16.4883 14.1667 14.3575 13.9717 12.3592C13.8758 11.3675 13.725 10.3342 13.4742 9.52083C13.3517 9.12167 13.1783 8.68583 12.9158 8.32417C12.6517 7.9625 12.1575 7.5 11.4075 7.5H2.75833C2.0075 7.5 1.51333 7.9625 1.25 8.325C0.986667 8.68583 0.813333 9.12167 0.691667 9.52083C0.440833 10.3342 0.29 11.3683 0.193333 12.3592C-9.93411e-08 14.3575 0 16.4883 0 17.0775V17.0833C0 17.4149 0.131696 17.7328 0.366116 17.9672C0.600537 18.2016 0.918479 18.3333 1.25 18.3333C1.58152 18.3333 1.89946 18.2016 2.13388 17.9672C2.3683 17.7328 2.5 17.4149 2.5 17.0833C2.5 16.5 2.5 14.4725 2.68333 12.6017C2.71417 12.2742 2.75083 11.96 2.7925 11.6667H3.33333V28.75C3.33384 29.0725 3.45898 29.3824 3.68261 29.6148C3.90623 29.8472 4.21103 29.9841 4.53329 29.997C4.85555 30.01 5.17033 29.8978 5.41183 29.684C5.65333 29.4703 5.80286 29.1714 5.82917 28.85L6.5375 20H7.62917L8.3375 28.85C8.36381 29.1714 8.51334 29.4703 8.75484 29.684C8.99634 29.8978 9.31112 30.01 9.63338 29.997C9.95564 29.9841 10.2604 29.8472 10.4841 29.6148C10.7077 29.3824 10.8328 29.0725 10.8333 28.75V11.6667H11.3733ZM25.8333 2.91667C25.8333 3.69021 25.526 4.43208 24.9791 4.97906C24.4321 5.52604 23.6902 5.83333 22.9167 5.83333C22.1431 5.83333 21.4013 5.52604 20.8543 4.97906C20.3073 4.43208 20 3.69021 20 2.91667C20 2.14312 20.3073 1.40125 20.8543 0.854272C21.4013 0.307291 22.1431 0 22.9167 0C23.6902 0 24.4321 0.307291 24.9791 0.854272C25.526 1.40125 25.8333 2.14312 25.8333 2.91667ZM26.5558 7.53833C26.4558 7.51327 26.3531 7.50067 26.25 7.50083H19.5817C19.4792 7.50083 19.3775 7.51417 19.2783 7.53917C18.35 7.7725 17.7258 8.33833 17.3342 9.11C16.99 9.78667 16.8225 10.6267 16.6842 11.4625L15.8508 16.4625C15.8217 16.6253 15.8252 16.7923 15.8611 16.9538C15.897 17.1152 15.9645 17.268 16.0599 17.4031C16.1552 17.5383 16.2764 17.6532 16.4165 17.7411C16.5566 17.8291 16.7127 17.8884 16.8759 17.9156C17.039 17.9428 17.206 17.9373 17.367 17.8995C17.528 17.8617 17.6799 17.7923 17.8139 17.6954C17.948 17.5984 18.0614 17.4758 18.1477 17.3347C18.234 17.1936 18.2914 17.0368 18.3167 16.8733L19.15 11.8733C19.2267 11.4092 19.2983 11.055 19.3708 10.7817L19.5833 13.3333C19.5833 14.8917 18.1717 22.0067 17.6725 24.475C17.65 24.5847 17.6501 24.6979 17.6728 24.8076C17.6954 24.9173 17.7402 25.0212 17.8044 25.113C17.8686 25.2048 17.9508 25.2825 18.0461 25.3414C18.1413 25.4004 18.2476 25.4393 18.3583 25.4558C21.7933 25.9675 24.04 25.9517 27.4742 25.4525C27.585 25.4364 27.6914 25.398 27.7869 25.3395C27.8824 25.281 27.965 25.2036 28.0296 25.1122C28.0942 25.0207 28.1396 24.9171 28.1628 24.8075C28.1861 24.698 28.1869 24.5848 28.165 24.475C27.6692 21.9667 26.25 14.6717 26.25 13.3333L26.4625 10.7817C26.535 11.055 26.6067 11.4083 26.6833 11.8733L27.5167 16.8733C27.5713 17.2004 27.7535 17.4925 28.0234 17.6851C28.1571 17.7806 28.3082 17.8487 28.4682 17.8857C28.6282 17.9227 28.7939 17.9279 28.9558 17.9008C29.1178 17.8738 29.2729 17.8151 29.4121 17.7282C29.5514 17.6412 29.6722 17.5277 29.7676 17.3941C29.8631 17.2604 29.9312 17.1093 29.9682 16.9493C30.0052 16.7893 30.0104 16.6236 29.9833 16.4617L29.15 11.4617C29.0108 10.6267 28.8433 9.78583 28.5 9.11C28.1067 8.3375 27.4833 7.7725 26.555 7.53833H26.5558ZM20.0058 29.27L19.6925 26.7592C20.5758 26.8675 21.415 26.9383 22.2417 26.97L21.6417 29.3692C21.5943 29.5576 21.4825 29.7236 21.3258 29.8384C21.169 29.9532 20.977 30.0096 20.783 29.9978C20.5891 29.986 20.4053 29.9069 20.2636 29.774C20.1218 29.6411 20.0309 29.4628 20.0067 29.27H20.0058ZM24.1917 29.3683L23.5967 26.9875C24.4428 26.9763 25.2881 26.928 26.13 26.8425L25.8267 29.27C25.8023 29.4628 25.7113 29.6409 25.5695 29.7737C25.4277 29.9065 25.2439 29.9856 25.0499 29.9973C24.856 30.0089 24.6641 29.9525 24.5074 29.8376C24.3506 29.7228 24.239 29.5568 24.1917 29.3683Z"
                fill="#4AA3C8"
            />
        </svg>
    );
}

function ChildrenIcon() {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.3299 11.445C14.3395 11.8596 14.2662 12.2719 14.1141 12.6577C13.9621 13.0436 13.7345 13.3951 13.4447 13.6917C13.1549 13.9883 12.8087 14.224 12.4265 14.3849C12.0443 14.5458 11.6338 14.6287 11.2191 14.6287C10.8044 14.6287 10.3939 14.5458 10.0117 14.3849C9.62949 14.224 9.28331 13.9883 8.99349 13.6917C8.70368 13.3951 8.47607 13.0436 8.32405 12.6577C8.17203 12.2719 8.09866 11.8596 8.10826 11.445C8.12162 10.6287 8.45528 9.8503 9.0373 9.27773C9.61932 8.70516 10.4031 8.38428 11.2195 8.38428C12.036 8.38428 12.8197 8.70516 13.4017 9.27773C13.9837 9.8503 14.3174 10.6287 14.3308 11.445H14.3299Z"
                fill="#4AA3C8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.5761 21.5401C7.34183 21.9149 6.96825 22.1813 6.53754 22.2807C6.10683 22.3801 5.65428 22.3044 5.27944 22.0701C4.9046 21.8358 4.63818 21.4622 4.53878 21.0315C4.43939 20.6008 4.51516 20.1483 4.74944 19.7734L4.75277 19.7684L4.7586 19.7593L4.7786 19.7276C4.88431 19.561 4.99294 19.3962 5.10444 19.2334C5.37472 18.8348 5.65878 18.4457 5.9561 18.0668C6.2886 17.6468 6.69694 17.1726 7.1286 16.7876C7.34444 16.5951 7.60444 16.3901 7.8986 16.2251C8.17527 16.0701 8.60777 15.8784 9.13694 15.8784H13.3003C13.8294 15.8784 14.2619 16.0701 14.5394 16.2251C14.8328 16.3901 15.0936 16.5951 15.3086 16.7876C15.7403 17.1726 16.1494 17.6468 16.4811 18.0676C16.9008 18.6011 17.2938 19.1551 17.6586 19.7276L17.6794 19.7593L17.6853 19.7676L17.6878 19.7726C17.6878 19.7726 17.6586 19.7276 17.6878 19.7726C17.9156 20.1472 17.9867 20.5964 17.8856 21.0231C17.7845 21.4497 17.5194 21.8193 17.1477 22.0518C16.776 22.2843 16.3276 22.3609 15.8998 22.2652C15.4719 22.1694 15.099 21.9089 14.8619 21.5401L14.8594 21.5368L14.8461 21.5159C14.8045 21.4503 14.7622 21.385 14.7194 21.3201V23.3901L15.3219 29.7193C15.3598 30.1507 15.2283 30.5799 14.9552 30.916C14.6821 31.2521 14.2889 31.4688 13.8588 31.52C13.4288 31.5712 12.9957 31.4531 12.6513 31.1905C12.3068 30.928 12.0781 30.5417 12.0136 30.1134L11.1628 24.1634L10.3128 30.1134C10.2519 30.545 10.0244 30.9355 9.67911 31.2013C9.33378 31.4672 8.89805 31.5872 8.46531 31.5356C8.03256 31.4841 7.63721 31.2651 7.36399 30.9256C7.09076 30.586 6.96139 30.153 7.0036 29.7193L7.7036 22.3776H7.7186V21.3193C7.6756 21.3845 7.6331 21.45 7.5911 21.5159L7.5786 21.5368L7.5761 21.5401Z"
                fill="#4AA3C8"
            />
            <path
                d="M31.4998 11.4443C31.4998 12.2694 31.1721 13.0608 30.5886 13.6442C30.0051 14.2277 29.2138 14.5555 28.3886 14.5555C27.5634 14.5555 26.7721 14.2277 26.1886 13.6442C25.6051 13.0608 25.2773 12.2694 25.2773 11.4443C25.2773 10.6191 25.6051 9.82774 26.1886 9.24427C26.7721 8.6608 27.5634 8.33301 28.3886 8.33301C29.2138 8.33301 30.0051 8.6608 30.5886 9.24427C31.1721 9.82774 31.4998 10.6191 31.4998 11.4443V11.4443Z"
                fill="#4AA3C8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.7514 21.4598C24.5156 21.8285 24.1443 22.0896 23.7176 22.1868C23.291 22.284 22.8432 22.2095 22.471 21.9794C22.0988 21.7494 21.832 21.3821 21.7282 20.957C21.6244 20.5319 21.692 20.083 21.9164 19.7073L21.9189 19.7023L21.9255 19.6932L21.9447 19.6615L22.0155 19.5498C22.3573 19.0179 22.7224 18.5013 23.1097 18.0015C23.438 17.5815 23.843 17.1065 24.2697 16.7207C24.4839 16.5282 24.7422 16.3215 25.0347 16.1565C25.3097 15.9998 25.743 15.8057 26.2747 15.8057H30.393C30.9247 15.8057 31.358 15.9998 31.6339 16.1557C31.9255 16.3223 32.1839 16.5282 32.398 16.7207C32.8255 17.1065 33.2297 17.5815 33.558 18.0015C33.9733 18.5351 34.3621 19.0888 34.723 19.6607L34.743 19.6932L34.7514 19.7073C34.9839 20.0833 35.0575 20.5362 34.9561 20.9664C34.8546 21.3967 34.5865 21.769 34.2105 22.0015C33.8346 22.234 33.3817 22.3076 32.9514 22.2062C32.5212 22.1048 32.1489 21.8366 31.9164 21.4607L31.9139 21.4565L31.9014 21.4357C31.776 21.2382 31.6468 21.0431 31.5139 20.8507C31.9039 22.7923 32.6722 25.4557 33.0739 26.8023C33.1074 26.9117 33.1178 27.0268 33.1045 27.1404C33.0913 27.254 33.0546 27.3636 32.9968 27.4623C32.939 27.561 32.8613 27.6466 32.7687 27.7137C32.6761 27.7809 32.5706 27.8281 32.4589 27.8523C29.5114 28.4665 27.448 28.4507 24.2472 27.8407C24.1323 27.8181 24.0235 27.7715 23.9279 27.704C23.8322 27.6364 23.7519 27.5495 23.6921 27.4489C23.6324 27.3482 23.5945 27.2361 23.581 27.1198C23.5675 27.0035 23.5787 26.8857 23.6139 26.774C24.0347 25.4207 24.8172 22.7857 25.188 20.8007C25.0434 21.0096 24.9028 21.2213 24.7664 21.4357L24.7539 21.4565L24.7514 21.4598V21.4598ZM24.6672 29.2657V30.389C24.6675 30.6919 24.7778 30.9844 24.9775 31.2121C25.1773 31.4398 25.453 31.5872 25.7532 31.6269C26.0535 31.6667 26.358 31.596 26.6101 31.4281C26.8622 31.2602 27.0448 31.0064 27.1239 30.714L27.453 29.494C26.5214 29.4609 25.5918 29.3847 24.6672 29.2657ZM29.3797 29.4907L29.7105 30.7148C29.7896 31.0073 29.9722 31.2611 30.2244 31.429C30.4766 31.5969 30.7812 31.6675 31.0815 31.6277C31.3819 31.5879 31.6575 31.4403 31.8572 31.2125C32.0569 30.9846 32.1671 30.692 32.1672 30.389V29.254C31.242 29.374 30.3119 29.4526 29.3797 29.4898V29.4907Z"
                fill="#4AA3C8"
            />
        </svg>
    );
}

function TicketType({type, count, selected, locked, onClick}) {
    let Icon = AdultIcon;
    if (type.toLowerCase().indexOf('barn') >
        -1 ||
        type.toLowerCase().indexOf('junior') >
        -1) {
        Icon = ChildrenIcon;
    } else if (type.toLowerCase().indexOf('senior') > -1) {
        Icon = OldCoupleAlt;
    }

    function interceptedOnClick(e) {
        e.preventDefault();

        if (locked || selected) {
            return;
        }

        onClick(type);
    }

    return (
        <Wrapper
            className="ticket-type"
            selected={selected}
            locked={locked}
            onClick={interceptedOnClick}
        >
            {count > 0 && <span className="ticket-type__count">{count}</span>}
            <Icon />
            {type}
        </Wrapper>
    );
}

export { TicketType };

const Wrapper = styled.div`
    width: 128px;
    height: 128px;

    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: center;
    flex-wrap: wrap;

    text-align: center;

    font-size: 14px;
    font-weight: 700;

    outline: 2px solid transparent;

    border: 2px solid #4aa3c8;
    border-radius: 4px;

    box-shadow: 0 4px 0 0 rgb(0 0 0 / 5%);

    background: white;

    transition: all 0.2s;

    position: relative;

    svg {
        flex-basis: 100%;
        margin-bottom: 13px;
        width: 40px;
        height: 40px;
        fill: rgb(74, 163, 200);
    }

    .ticket-type__count {
        width: 32px;
        height: 32px;

        font-size: 18px;
        font-family: Adelle, serif;
        font-weight: 700;
        text-align: center;
        line-height: 32px;
        color: white;

        position: absolute;
        top: 4px;
        right: 4px;

        background: #55bd9d;

        border-radius: 100%;
    }

    ${(props) =>
        props.selected &&
        css`
            border: 2px solid #00a5cc;
            outline: 2px solid #00a5cc;
        `}

    ${(props) =>
        props.locked &&
        css`
            opacity: 0.3;
            cursor: default;
        `}
`;
